import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { components } from '@/types/api.generated';

export type ExceptionOrCancelledWire = components['schemas']['DispatchExceptionOrCancelled'];

/**
 * One shipping day's exception and cancelled delivery jobs (#2481 read
 * endpoint). Shared by the exception pane and today's focus cards (#2485).
 */
export function useExceptionOrCancelled(date: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.dispatch.exceptionOrCancelled(date),
    queryFn: () =>
      http.get<ExceptionOrCancelledWire>('/api/dispatch/exception-or-cancelled', {
        params: { date },
      }),
    enabled: options?.enabled ?? true,
  });
}
